import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ShareButtons = ({ article }) => {
  const [copied, setCopied] = useState(false);

  const shareUrl = typeof window !== 'undefined' ? window.location?.href : '';
  const shareTitle = article?.title || '';

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard?.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy link:', err);
    }
  };

  const handleTwitterShare = () => {
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareTitle)}&url=${encodeURIComponent(shareUrl)}`;
    window.open(twitterUrl, '_blank', 'width=550,height=420');
  };

  const handleFacebookShare = () => {
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
    window.open(facebookUrl, '_blank', 'width=550,height=420');
  };

  const handleLinkedInShare = () => {
    const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;
    window.open(linkedInUrl, '_blank', 'width=550,height=420');
  };

  return (
    <div className="flex items-center gap-12 mb-32">
      <span className="text-sm font-medium text-muted-foreground">Share:</span>
      <div className="flex items-center gap-8">
        <button
          onClick={handleTwitterShare}
          className="p-8 bg-muted hover:bg-muted/80 rounded-lg transition-smooth min-h-[36px] min-w-[36px] flex items-center justify-center"
          aria-label="Share on Twitter"
        >
          <Icon name="Twitter" size={16} color="var(--color-foreground)" />
        </button>
        <button
          onClick={handleFacebookShare}
          className="p-8 bg-muted hover:bg-muted/80 rounded-lg transition-smooth min-h-[36px] min-w-[36px] flex items-center justify-center"
          aria-label="Share on Facebook"
        >
          <Icon name="Facebook" size={16} color="var(--color-foreground)" />
        </button>
        <button
          onClick={handleLinkedInShare}
          className="p-8 bg-muted hover:bg-muted/80 rounded-lg transition-smooth min-h-[36px] min-w-[36px] flex items-center justify-center"
          aria-label="Share on LinkedIn"
        >
          <Icon name="Linkedin" size={16} color="var(--color-foreground)" />
        </button>
        <button
          onClick={handleCopyLink}
          className="p-8 bg-muted hover:bg-muted/80 rounded-lg transition-smooth min-h-[36px] min-w-[36px] flex items-center justify-center relative"
          aria-label="Copy link"
        >
          {copied ? (
            <Icon name="Check" size={16} color="var(--color-success)" />
          ) : (
            <Icon name="Link" size={16} color="var(--color-foreground)" />
          )}
        </button>
      </div>
      {copied && (
        <span className="text-xs text-success font-medium">Link copied!</span>
      )}
    </div>
  );
};

export default ShareButtons;